import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';


const FormulationPreACAAging = ({ modificar = {}, onSave}) => {
  const timestamp = new Date().toLocaleString(); 
  const [isEditing, setIsEditing] = useState(true);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [comments, setComments] = useState(modificar.Comments || []);
  const [newComment, setNewComment] = useState('');
  
  const StatusMoods = [
    'NOT OUR PATIENT', 'ALREADY HAS AN APPOINTMENT', 'OPEN', 'INSURANCE CHANGED', 'OTHER PCP', 'PENDING', 'REFUSED'
  ]

  const [form, setForm] = useState({
    MemberID: modificar.MemberID,
    MemberFullName: modificar.MemberFullName,
    DOB: modificar.DOB,
    Age: modificar.Age,
    MemberPlan: modificar.MemberPlan,
    MemberPlanEffectiveDate: modificar.MemberPlanEffectiveDate,
    MemberEmail: modificar.MemberEmail,
    MemberPhoneNumber: modificar.MemberPhoneNumber, 
    CallLog: modificar.CallLog,
    Comments: modificar.Comments,
    OfficeLocation: modificar.OfficeLocation,
    Update: modificar.Update,
    AddressLine1: modificar.AddressLine1,
    CityName: modificar.CityName,
    ZipCode: modificar.ZipCode,
    Country: modificar.Country,
    PCPFullName: modificar.PCPFullName,
    Type: modificar.Type
  });

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        const timestamp = new Date().toLocaleString();
        const newSystemicBilling = {
        ...form
        };
        newSystemicBilling.Update = timestamp;
        onSave(newSystemicBilling);
    };

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: form.PCPFullName }];
    setComments(updatedComments);
    handleChange('Comments', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Roster Againg</Typography>
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Member Full Name:</strong></Typography></Grid>
          <TextField
            disabled
            fullWidth
            value={form.MemberFullName}
          />
          <Grid item width="100%"><Typography><strong>DOB:</strong></Typography></Grid>
          <TextField
            disabled
            type="date"
            fullWidth
            value={form.DOB}
          />
          <Grid item width="100%"><Typography><strong>Age:</strong></Typography></Grid>
          <TextField
            disabled
            fullWidth
            value={form.Age}
          />
          <Grid item width="100%"><Typography><strong>Call Log:</strong></Typography></Grid>
          <TextField
              select
              fullWidth
              value={form.CallLog}
              onChange={e => handleChange('CallLog', e.target.value)}
            >
            {StatusMoods.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="subtitle1" fontWeight="bold">Related Comments</Typography>
            {isEditing && (
              <IconButton color="primary" onClick={() => setOpenCommentDialog(true)}>
                <AddIcon />
              </IconButton>
            )}
          </Box>
          <Table size="medium">
            <TableHead>
              <TableRow>
                <TableCell><strong>Timestamp</strong></TableCell>
                <TableCell><strong>Comments</strong></TableCell>
                <TableCell><strong>Staff Name</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comments.map((comment, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{comment.Timestamp}</TableCell>
                  <TableCell>{comment.Comments}</TableCell>
                  <TableCell>{comment.StaffName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
        
        <Button 
            fullWidth
            variant="contained"
            sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
                backgroundColor: '#bdbdbd',
                color: 'black',
                '&:hover': { backgroundColor: '#9e9e9e' }
            }}
            onClick={handleSubmit}
            >
            <Typography sx={{ color: '#117a65' }}>Save</Typography>
        </Button>
      </Paper>
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FormulationPreACAAging;
